module.exports = __webpack_public_path__ + "f60a7d82ab25379a24e105a319f30c7f.svg";